import * as React from 'react';
import { useVisitedOffersContext } from '@cian/frontend-visited-offers-widget';
import { useSelector } from 'react-redux';
import { getNewbuildingId } from '../../selectors/newbuilding';

export const VisitedOffersUpdater = () => {
  const { isLoaded, setOfferVisited, isOfferVisited } = useVisitedOffersContext();
  const id = useSelector(getNewbuildingId);

  React.useEffect(() => {
    if (isLoaded && !isOfferVisited(id)) {
      setOfferVisited(id);
    }
  }, [isLoaded, id, setOfferVisited, isOfferVisited]);

  return null;
};
